import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from '../../services/storage.service';
import {locale} from "devextreme/localization";
import {SettingsService} from "../../services/settings.service";

@Component({
    selector: 'app-language',
    templateUrl: './language.component.html',
    styleUrls: ['./language.component.scss'],
    standalone: false
})
export class LanguageComponent {
  langSelect: string;
  arrayLang: Array<string>;
  @Input() showText = false;

  constructor(
    public translate: TranslateService,
    private storageService: StorageService,
    private settings: SettingsService,
  ) {
    this.langSelect = translate.getDefaultLang();
    this.arrayLang = translate.getLangs();
  }

  onSelect(language): void {
    this.langSelect = language;
    this.translate.use(language);
    this.translate.setDefaultLang(language);
    this.storageService.addToLocalStorage('lang', language);
    locale(this.settings.getLangForLocale(language));
  }
}
